import React from "react";
import "./PageHeader.css";

const ImageWithHeadline = ({ imageUrl, headline, isFirstArticle }) => {
  return (
    <div
      className="header-image-container"
      style={isFirstArticle ? { marginTop: "-140px" } : {}}
    >
      <img src={imageUrl} alt="Background" className="background-image" />

      {/* Primary color overlay */}
      <div className="primary-overlay"></div>

      <div className="headline-overlay">
        <h2 className="text-4xl font-light text-white tracking-wide mb-4">
          {headline}
        </h2>
      </div>
    </div>
  );
};

export default ImageWithHeadline;
